import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'

import {Text} from '@daedalus/atlas/src/components/designSystem/Text'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import {
  getFreezeSelectedContext,
  getOfferEligibility
} from '../../modules/selector'
import {findRoomByOfferId} from '../../utils/offer'
import {FormattedExpirationDate} from '../common/FormattedExpirationDate'
import {HotelCard} from '../HotelCard'

const CenterAlignWrapper = styled.div`
  text-align: center;
`
const FreezeExplanationText = styled(Text)(
  ({theme}) => `
    padding: 0 ${theme.layout.spacing.s500}px;
    `
)
export const HotelCardWithHeaders = () => {
  const {hotel, searchDetail, rooms, sapiMatchedOffer} = useSelector(
    getFreezeSelectedContext
  )
  const {checkIn, checkOut, roomsSplit} = searchDetail || {}
  const {hotelName, starRating, imageURIs} = hotel || {}

  const {response: offerCheckResponse} = useSelector(getOfferEligibility)
  const room = findRoomByOfferId(rooms || [], sapiMatchedOffer?.id)

  return (
    <>
      <CenterAlignWrapper>
        <Text variant="titleXL">
          <FormattedMessageWrapper
            id="df.freezeOverlayTitle"
            defaultMessage="Freeze this price for free"
          />
        </Text>

        {offerCheckResponse?.expiresAt && (
          <FreezeExplanationText variant="bodyM">
            <FormattedMessageWrapper
              id="df.freezeOverlayExplanation"
              defaultMessage="Lock in the current price until {date} and book when you're ready."
              values={{
                date: (
                  <FormattedExpirationDate
                    expiresAt={offerCheckResponse?.expiresAt}
                  />
                )
              }}
            />
          </FreezeExplanationText>
        )}
      </CenterAlignWrapper>

      <HotelCard
        hotelName={hotelName as string}
        checkIn={checkIn}
        checkOut={checkOut}
        roomsSplit={roomsSplit}
        imageUrl={imageURIs?.[0] as string}
        rating={starRating}
        room={room}
        offer={sapiMatchedOffer}
        shouldShowPayNow
      />
    </>
  )
}
